import {gql} from "@apollo/client/core";
import {CustomerAddressFragment} from "../customer-address-fragment";
import {OrderHistoryProductViewFragment} from "./order-history-product-view-fragment";
import {OrderHistoryPaymentViewFragment} from "./order-history-payment-view-fragment";

export const OrderHistoryViewFragment = gql`
    fragment OrderHistoryViewFragment on OrderHistoryView {
        id
        customerId
        totalVolume
        orderDate
        status
        source
        products {
            ...OrderHistoryProductViewFragment
        }
        packslips {
            packslipId
            orderId
            shipDate
            packages {
                packageId
                trackingNumber
                trackingLink
            }
        }
        shippingMethod {
            methodId
            carrierCode
            carrierName
            methodName
        }
        address {
            ...CustomerAddressFragment
        }
        warehouse {
            warehouseId
            timezone
        }
        exclusiveTotalPrice
        total
        totalPrice
        baseFreight
        totalFreight
        taxCost
        taxExempt
        totalTaxes
        totalDuty
        totalHandling
        currencyCode
        autoOrderDiscount
        totalIoReward
        bpsReference {
            bpsNumber
            cashPSAccountNumber
        }
        charity {
            id
            charityCode
            name
        }
        nfr
        taxRates {
            taxRate
            taxAmount
        }
        vouchersPayments {
            ...OrderHistoryPaymentViewFragment
        }
        nonVouchersPayments {
            ...OrderHistoryPaymentViewFragment
        }
        shippingCost
        shippingCostExclusive
        shippingTax
        shippingTaxInclusive
        taxInclusive
    }
    ${CustomerAddressFragment}
    ${OrderHistoryProductViewFragment}
    ${OrderHistoryPaymentViewFragment}
`;
